"use strict";
import { useContext, useEffect } from "react";
import { OwnerModuleContext } from "../context";
export const BodyModuleClass = () => {
  const ownerContext = useContext(OwnerModuleContext);
  useEffect(() => {
    if (ownerContext) {
      const id = ownerContext.id;
      document.body.classList.add(id);
      return () => {
        document.body.classList.remove(id);
      };
    }
  }, [ownerContext == null ? void 0 : ownerContext.id]);
  return null;
};
